export const QUERY_KEYS = {
    moengage_campaign: 'moengage-campaign'
}

export const MUTATION_KEYS = {
    seen_moengage_combination: 'seen-moengage-combination',
    get_free_morgis: 'get-free-morgis'
}
